
      import ArrowUp from './arrow-up.vue'
      import type { App, Plugin } from 'vue'

      export const ArrowUpPlugin: Plugin = {
        install(app: App) {
          app.component('ArrowUp', ArrowUp)
        },
      }
      export { ArrowUp }
      